import React, { Dispatch, SetStateAction} from "react";
import { ChatGPTAppMetadataType } from "../../shared-components/common/types/AppMetadata";
import { IAudience, IExperienceType, IVariant } from "../../shared-components/types";

export type EntryFieldExtensionContextType = {
  entryField: unknown;
  setFieldData: (data: unknown) => void;
  loading: boolean;
  getToken: () => string;
  appMetadata: ChatGPTAppMetadataType | null;
  errorMessage: string | null;
  setErrorMessage: (error: string | null) => void;
  errorHeaderMessage: string,
  setErrorHeaderMessage: Dispatch<SetStateAction<string>>,
  showPersonalize: boolean,
  audienceList: IAudience[],
  experienceType: IExperienceType | null,
  currentVariant: IVariant | null,
  localeList: Record<string, string> | null
};

export const EntryFieldExtensionContext = React.createContext<EntryFieldExtensionContextType>({
  entryField: null,
  setFieldData: () => {},
  loading: false,
  appMetadata: null,
  getToken: () => "",
  errorMessage: null,
  setErrorMessage: () => {},
  errorHeaderMessage: "",
  setErrorHeaderMessage: () => {},
  showPersonalize: false,
  audienceList: [],
  experienceType: null,
  currentVariant: null,
  localeList: null
});
